export var InquiryInclude = {
    owner: true,
    category: true,
    actionAreas: true,
    location: true,
    selectedSolution: true,
    offeredSolutions: true,
};
//# sourceMappingURL=Inquiry.js.map